var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"app-menu"},_vm._l((_vm.menuItems),function(item){return _c('require-permissions',{key:item.route.name,attrs:{"all":item.permissions}},[_c('menu-item',{attrs:{"href":_vm.path(item.route),"icon":item.icon,"title":_vm.$t(item.label)}})],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }